import { render } from "./head-card.vue?vue&type=template&id=a51ef442&scoped=true"
import script from "./head-card.vue?vue&type=script&lang=js"
export * from "./head-card.vue?vue&type=script&lang=js"

import "./head-card.vue?vue&type=style&index=0&id=a51ef442&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a51ef442"]])

export default __exports__